import { Lazy } from "../core/lazy";
import { KnockoutHelper } from "../knockout/knockout-helper";
import { DxOptionFactory } from "../devexpress/factory/dx-option-factory";
import { ControlType } from "../devexpress/controltype";
import { IdName } from "../types/interfaces";
import { UrlHelper } from "../core/html/url-helper";
import { DialogResultVm } from "../checkresultdialog/dialogresultvm";
import { LoadVm } from "../loading/loadvm";
import { DialogHelper } from "../helper/dialog-helper";

export class ChangeMarketerHeaderVm {
	public static getInstance = Lazy.singleton(ChangeMarketerHeaderVm);
	private static readonly headerId = "nautilus-header-current-marketer";

	public static initialize() {
		$("#" + ChangeMarketerHeaderVm.headerId).click(() => {
			let header = ChangeMarketerHeaderVm.getInstance();
			if (!header.isInitialized) {
				header.initializeHeader();
				header.enableEditMode();
			}
		});

		if (window.localStorage) {
			const marketerKey = "current-marketer";
			let initialMarketer = String(UrlHelper.getUserMarketerId());
			localStorage.setItem(marketerKey, initialMarketer);

			window.addEventListener("focus", async () => {
				let currentMarketer = localStorage.getItem(marketerKey);
				if (initialMarketer === currentMarketer) {
					return;
				}

				await DialogHelper.alertAsync("Sie haben den Vermarkter in einem anderen Fenster geändert. Das Fenster muss jetzt neugeladen werden.", "Vermarkter-Wechsel");
				window.sessionStorage?.clear();
				window.location.reload();
			});
		}
	}

	private isInitialized = false;
	private factory = DxOptionFactory.getInstance();
	private marketers: KnockoutObservableArray<IdName> = ko.observableArray([]);
	private currentMarketer = ko.observable(0);

	private canEdit = ko.pureComputed(() => this.marketers().length >= 2);
	private editMode = ko.observable(false);

	constructor() {
		this.marketers((window as any).marketers || []);
	}

	public marketerOptions = this.factory.createOptions({
		type: ControlType.SelectBox,
		options: {
			value: this.currentMarketer,
			dataSource: this.marketers,
			valueExpr: "id",
			displayExpr: "name",
			width: 170
		}
	});

	public okOptions = this.factory.createOptions({
		type: ControlType.Button,
		options: {
			icon: "fa fa-check",
			hint: "OK",
			onClick: () => {
				this.changeMarketerAsync(this.currentMarketer());
			},
			disabled: ko.pureComputed(() => UrlHelper.getUserMarketerId() === this.currentMarketer()),
		}
	});
	public cancelOptions = this.factory.createOptions({
		type: ControlType.Button,
		options: {
			icon: "fa fa-times",
			hint: "Abbrechen",
			onClick: () => {
				this.editMode(false);
			}
		}
	});

	public enableEditMode() {
		if (this.canEdit() && !this.editMode()) {
			this.currentMarketer(UrlHelper.getUserMarketerId());
			this.editMode(true);
		}
	}

	public async changeMarketerAsync(newMarketerId: number) {
		LoadVm.startLoading({ text: "Vermarkter wird gewechselt" });

		let url = UrlHelper.getDataUrl("change-marketer");
		let params = { newMarketerId };
		let result = await DialogResultVm.getDataWithWarningDialogRetryAsync({ url, params, method: "POST" });
		if (!result) {
			LoadVm.endLoading();
			return;
		}

		window.localStorage?.clear();
		window.sessionStorage?.clear();
		window.location.reload();
	}

	private initializeHeader() {
		if (this.isInitialized) {
			return;
		}

		KnockoutHelper.applyBindingsIfElementExists(this, document.getElementById(ChangeMarketerHeaderVm.headerId));
		this.isInitialized = true;
	}
}